var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62999 13.6865H1.90643C1.12648 13.6865 0.494202 13.0542 0.494202 12.2743V2.21215C0.494202 1.4322 1.12648 0.799927 1.90643 0.799927H8.96756C9.74751 0.799927 10.3798 1.4322 10.3798 2.21215V7.5479",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85516 3.24554H5.78922",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85516 5.99506H8.25363",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77954 8.6181H6.44493",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4531,
    cy: 11.223,
    r: 2.52708,
    stroke: "white",
    strokeWidth: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4015 9.9209V12.5922",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09576 11.2222H10.4268H11.8176",
    stroke: "white",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateButtonIcon);
export default __webpack_public_path__ + "static/media/generateButtonIcon.56c5568f848a8548162e859225ec6746.svg";
export { ForwardRef as ReactComponent };